import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { InsightsService } from '../../../../../shared/services/insights.service';
import { IAccountAccess } from '../../account.component';

@Component({
	selector: 'app-dialog-account-groups',
	templateUrl: './dialog-account-groups.component.html',
	styleUrls: ['./dialog-account-groups.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DialogAccountGroupsComponent implements OnInit, OnDestroy {
	groups: string = '';
	form: UntypedFormGroup;
	groupsControl = new UntypedFormControl('');
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		public dialogRef: MatDialogRef<DialogAccountGroupsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IAccountAccess,
		public insightsService: InsightsService,
	) {
		this.form = new UntypedFormGroup({
			groups: this.groupsControl,
		});
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	ngOnInit(): void {
		this.data.groupIds.forEach((element) => {
			this.groups += `${element}\r\n`;
		});
		this.groupsControl.setValue(this.groups);
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	saveAccountGroups() {
		const enteredGroups: string = this.groupsControl.value;
		const groupList = enteredGroups.split(/\r?\n/);
		const results = groupList.filter((element) => {
			if (Object.keys(element).length !== 0) {
				return true;
			}

			return false;
		});
		this.insightsService
			.addAccountGroups(results)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((data) => {
				console.log(JSON.stringify(data));
				this.dialogRef.close();
			});
	}
}
